import { StyleMapToken } from 'antd/es/theme/interface'

export const StyleMap: StyleMapToken = {
  lineWidthBold: 1,
  borderRadiusXS: 2,
  borderRadiusSM: 4,
  borderRadiusLG: 8,
  borderRadiusOuter: 4,
}
